import React, { useEffect, useRef, useState } from "react"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"

import StrTable from "./StrTable"
import StrHeader from "./StrHeader"
import { getStockTransferRequests } from "services"
import { Navbar, PageLoader } from "components"
import classes from "./index.module.scss"

const limit = 30

const StockTransferRequests = () => {
  const history = useHistory()

  const cashierBranchId =
    useSelector(state => state.userAccountInfo.branchId)

  const [hasMore, setHasMore] = useState(true)
  const [skip, setSkip] = useState(0)
  const [stockTransferRequests, setStockTransferRequests] = useState(null)

  const unmount = useRef(false)

  const handleGoBack = () => {
    history.push("/settings")
  }

  const loadMore = async () => {
    try {
      const response =
        await getStockTransferRequests({
          skip,
          limit,
          sourceBranchId: cashierBranchId,
          destinationBranchId: cashierBranchId
        })

      if (unmount.current) return

      response.length !== limit
        ? setHasMore(false)
        : setSkip(prev => prev += limit)

      setStockTransferRequests(prev => [...prev, ...response])
    } catch (err) {
      console.log(err)
    }
  }

  const getTransferRequests = async () => {
    if (stockTransferRequests !== null) {
      setSkip(0)

      setHasMore(true)

      setStockTransferRequests(null)
    }

    try {
      const response =
        await getStockTransferRequests({
          skip: 0,
          limit,
          sourceBranchId: cashierBranchId,
          destinationBranchId: cashierBranchId
        })

      if (unmount.current) return

      response.length !== limit
        ? setHasMore(false)
        : setSkip(prev => prev += limit)

      setStockTransferRequests(response)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    unmount.current = false

    getTransferRequests()

    return () => { unmount.current = true }
  }, [])

  if (stockTransferRequests === null) return <PageLoader />

  return (
    <div className={classes["container"]}>
      <Navbar
        variant="compact"
        title="درخواست موجودی"
        onLeftIconPress={handleGoBack}
      />

      <StrHeader
        setStockTransferRequests={setStockTransferRequests}
      />

      <StrTable
        hasMore={hasMore}
        skip={skip}
        loadMore={loadMore}
        stockTransferRequests={stockTransferRequests}
        setStockTransferRequests={setStockTransferRequests}
      />
    </div>
  )
}

export default StockTransferRequests